import classNames from 'classnames';
import { observer } from 'mobx-react';

import LayoutPicker from './ModularConfigurator/LayoutPicker/LayoutPicker';
import ModularComponentConfigurator from './ModularConfigurator/ModularComponentConfigurator/ModularComponentConfigurator';
import ModularConfiguratorNavigation from './ModularConfigurator/ModularConfiguratorNavigation/ModularConfiguratorNavigation';
import ModularConfiguratorPreview from './ModularConfigurator/ModularConfiguratorPreview/ModularConfiguratorPreview';
import ModularConfiguratorSection from './ModularConfigurator/ModularConfiguratorSection/ModularConfiguratorSection';
import ModularConfiguratorSummary from './ModularConfigurator/ModularConfiguratorSummary/ModularConfiguratorSummary';
import css from './ModularConfiguratorCoordinator.css';
import ModularConfiguratorCoordinatorState from './ModularConfiguratorCoordinatorState';

interface ModularConfiguratorCoordinatorProps {
  state: ModularConfiguratorCoordinatorState;
  className?: string;
  showPerformance?: boolean;
}

const ModularConfiguratorCoordinator = observer(
  ({ className, state, showPerformance }: ModularConfiguratorCoordinatorProps) => {
    return (
      <div className={classNames(css.container, className)}>
        <ModularConfiguratorSection
          className={classNames(css.element, css.view, { [css.hidden]: !state.isLayoutModeActive })}
          hidden={!state.isLayoutModeActive}
        >
          <LayoutPicker state={state.layoutPicker} disabled={state.configurator.loadingIndicator.isLoading} />
        </ModularConfiguratorSection>
        <ModularConfiguratorSection
          className={classNames(css.element, css.view, { [css.hidden]: !state.isComponentModeActive })}
          hidden={!state.isComponentModeActive}
        >
          <ModularComponentConfigurator state={state} />
        </ModularConfiguratorSection>
        <ModularConfiguratorSection
          className={classNames(css.element, css.preview, { [css.withSummary]: state.isSummary })}
        >
          <ModularConfiguratorPreview state={state} readonly={state.isSummary} showPerformance={showPerformance} />
        </ModularConfiguratorSection>
        <ModularConfiguratorSection
          className={classNames(css.element, css.summary, { [css.hidden]: !state.isSummary })}
          hidden={!state.isSummary}
        >
          <ModularConfiguratorSummary state={state} />
        </ModularConfiguratorSection>
        <ModularConfiguratorNavigation
          className={classNames(css.navigation, { [css.hidden]: state.isSummary })}
          state={state}
          hidden={state.isSummary}
        />
      </div>
    );
  },
);

export default ModularConfiguratorCoordinator;
